export default __webpack_public_path__ + "static/media/auth.afd2f9dc.svg";